import { configureStore } from "@reduxjs/toolkit";
import infoReducer from "./infoSlice";
import dataReducer from "./dataSlice";
import pdfReducer from "./pdfSlice";



export const store = configureStore({
  reducer: {
    info: infoReducer,
    data: dataReducer,
    pdf: pdfReducer,
  },
});


